var map = {
	"./csharp.js": "G5Hi",
	"./generate.js": "J7jo",
	"./golang.js": "5BSP",
	"./java.js": "Bhqz",
	"./javascript.js": "mDPn",
	"./php.js": "zYya",
	"./python.js": "ATrJ",
	"./shell.js": "kHJ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BPx7";


//////////////////
// WEBPACK FOOTER
// ./src/utils/code ^\.\/.*\.js$
// module id = BPx7
// module chunks = 3